export default __webpack_public_path__ + "static/media/african_nigerian_kenyan_couple_lovrican_app.58f12bb9.webp";